import React from 'react';
import {motion} from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import SEOHead from '../components/SEOHead';
import * as FiIcons from 'react-icons/fi';

const {FiArrowLeft, FiCalendar} = FiIcons;

const BlogPage = () => {
  const blogTopics = [
    {letter: 'A', topic: 'Angebote & Aufträge', description: 'Professionelle Angebote erstellen und in Rechnungen umwandeln'},
    {letter: 'B', topic: 'Belegerfassung digital', description: 'Belege scannen, automatisch erkennen und rechtssicher archivieren'},
    {letter: 'C', topic: 'Cloud-Buchhaltung', description: 'Überall arbeiten mit der sicheren Cloud-Lösung von Lexware'},
    {letter: 'D', topic: 'DATEV-Schnittstelle', description: 'Nahtloser Datenaustausch mit deinem Steuerberater'},
    {letter: 'E', topic: 'E-Bilanz & Jahresabschluss', description: 'Elektronische Übermittlung der Bilanz direkt ans Finanzamt'},
    {letter: 'F', topic: 'Finanzen im Überblick', description: 'Liquidität und Rentabilität jederzeit im Blick behalten'},
    {letter: 'G', topic: 'GoBD-konforme Archivierung', description: 'Rechtssichere Aufbewahrung aller Geschäftsunterlagen'},
    {letter: 'H', topic: 'Hauptbuch & Kontenplan', description: 'Standardisierte Kontenpläne für jede Rechtsform'},
    {letter: 'I', topic: 'Inventur & Warenwirtschaft', description: 'Lagerverwaltung und automatische Bestandsführung'},
    {letter: 'J', topic: 'Jahresabschluss', description: 'GuV, Bilanz und Anhang professionell erstellen'},
    {letter: 'K', topic: 'Kassenbuch elektronisch', description: 'GoBD-konforme Kassenbuchführung mit Tagesabschluss'},
    {letter: 'L', topic: 'Lohn & Gehalt', description: 'Integrierte Lohnabrechnung für bis zu 50 Mitarbeiter'},
    {letter: 'M', topic: 'Mahnwesen automatisch', description: 'Automatische Mahnläufe mit individuellen Mahnstrategie'},
    {letter: 'N', topic: 'Nummernkreise', description: 'Flexible Nummerierung für Belege und Kunden'},
    {letter: 'O', topic: 'Online Banking', description: 'Kontoumsätze automatisch abrufen und zuordnen'},
    {letter: 'P', topic: 'Projektverwaltung', description: 'Projektbezogene Auswertungen und Nachkalkulationen'},
    {letter: 'Q', topic: 'Quartalsberichte', description: 'Betriebswirtschaftliche Auswertungen für jeden Zeitraum'},
    {letter: 'R', topic: 'Rechnungen & Gutschriften', description: 'Professionelle Rechnungsstellung mit Zahlungsüberwachung'},
    {letter: 'S', topic: 'Steuerberater-Zugang', description: 'Sicherer Online-Zugang für den Steuerberater'},
    {letter: 'T', topic: 'Terminverwaltung', description: 'Termine und Wiedervorlagen zentral verwalten'},
    {letter: 'U', topic: 'Umsatzsteuer-Voranmeldung', description: 'Direkte elektronische Übermittlung an das Finanzamt'},
    {letter: 'V', topic: 'Vorlagen & Briefpapier', description: 'Individuelle Gestaltung aller Geschäftspapiere'},
    {letter: 'W', topic: 'Warenwirtschaft', description: 'Artikel-, Lager- und Lieferantenverwaltung integriert'},
    {letter: 'X', topic: 'XML-Schnittstellen', description: 'Moderne Datenformate für den Austausch mit Behörden'},
    {letter: 'Y', topic: 'Jahresplanung', description: 'Budgetplanung und Soll-Ist-Vergleiche'},
    {letter: 'Z', topic: 'Zeiterfassung', description: 'Arbeitszeiten erfassen und automatisch abrechnen'}
  ];

  return (
    <>
      <SEOHead 
        title="Lexware ABC - Alle Funktionen von A bis Z | Smarte Buchhaltung Online" 
        description="Entdecken Sie alle 60+ Funktionen von Lexware Office von A bis Z. Professionelle Buchhaltungssoftware mit Angeboten, Belegerfassung, DATEV-Export und mehr." 
        keywords="lexware office funktionen,buchhaltungssoftware funktionen,lexware abc,datev export,belegerfassung digital,umsatzsteuer voranmeldung,online banking buchhaltung" 
        canonical="https://smarte-buchhaltung.online/#/lexware-abc" 
      />
      <div className="min-h-screen bg-gray-50 pt-20 pb-16">
        <div className="container mx-auto px-6 lg:px-8">
          {/* Header */}
          <motion.div 
            initial={{opacity: 0, y: 30}} 
            animate={{opacity: 1, y: 0}} 
            transition={{duration: 0.6}} 
            className="text-center mb-16"
          >
            <motion.a 
              href="#/" 
              whileHover={{scale: 1.05}} 
              className="inline-flex items-center text-red-500 hover:text-red-600 mb-6"
            >
              <SafeIcon icon={FiArrowLeft} className="mr-2" />
              Zurück zur Startseite
            </motion.a>
            <h1 className="text-4xl lg:text-6xl font-bold text-gray-900 mb-6">
              Lexware ABC
            </h1>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Kurzer Überblick über Funktionen und Begriffe - verständlich erklärt
            </p>
          </motion.div>
          
          {/* ABC Grid */}
          <div className="grid md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 mb-16">
            {blogTopics.map((item, index) => (
              <motion.div 
                key={index} 
                initial={{opacity: 0, y: 30}} 
                animate={{opacity: 1, y: 0}} 
                transition={{duration: 0.6, delay: index * 0.02}} 
                className="bg-[#F3F1EE] p-4 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 cursor-pointer group"
              >
                <div className="flex items-start space-x-3">
                  <div className="bg-[#F3F1EE] text-[#E30613] w-8 h-8 rounded-full flex items-center justify-center font-bold text-sm flex-shrink-0 border border-[#E30613]">
                    {item.letter}
                  </div>
                  <div className="flex-1 min-w-0">
                    <h3 className="font-bold text-sm text-gray-900 mb-1 group-hover:text-[#E30613] transition-colors line-clamp-2">
                      {item.topic}
                    </h3>
                    <p className="text-gray-600 text-xs leading-relaxed line-clamp-3">{item.description}</p>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
          
          {/* CTA Section */}
          <motion.div 
            initial={{opacity: 0, y: 30}} 
            animate={{opacity: 1, y: 0}} 
            transition={{duration: 0.6, delay: 0.4}} 
            className="text-center"
          >
            <div className="bg-[#F3F1EE] p-8 rounded-xl shadow-lg max-w-2xl mx-auto">
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                Neugierig auf über 60 Funktionen?
              </h3>
              <p className="text-gray-600 mb-6">
                In unserem kostenfreien Erstgespräch zeige ich dir, welche Funktionen für dein Unternehmen besonders relevant sind und wie du optimal mit Lexware Office starten kannst.
              </p>
              <div className="flex justify-center">
                <motion.a 
                  href="https://nextcloud.managershop.com/index.php/apps/appointments/pub/Gb05r41McyYVyGQE/form" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  whileHover={{scale: 1.05}} 
                  whileTap={{scale: 0.95}} 
                  className="bg-[#E30613] hover:bg-[#C10511] text-white px-8 py-3 rounded-lg font-semibold transition-all duration-300 flex items-center space-x-2"
                >
                  <SafeIcon icon={FiCalendar} />
                  <span>Lass uns sprechen</span>
                </motion.a>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </>
  );
};

export default BlogPage;